'use client';
import { fetchAdvisories } from '@eliadmin/core/src/api/advisories/advisories-api';
import type { Advisory } from '@eliadmin/core/src/api/advisories/advisories-types';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { AddAdvisoryDialog } from '@eliadmin/core/src/components/advisory/add-advisory-dialog';
import { AdvisorySearchItem } from '@eliadmin/core/src/components/advisory/advisory-search-item';
import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { SearchBar } from '@eliadmin/core/src/components/ui/search-bar';
import { useSearchBar } from '@eliadmin/core/src/hooks/search-bar/use-search-bar';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiEdit3 } from 'react-icons/fi';

export type AdvisoryHeaderProps = {
  className?: {
    wrapper?: string;
    header?: string;
  };
};

export function AdvisoryHeader(props: AdvisoryHeaderProps) {
  const locale = useLocaleStore(s => s.currentLocale);

  const { t } = useTranslations();

  const me = useCustomerStore(s => s.me);

  const { items, isLoading, searchQuery, setSearchQuery } = useSearchBar({
    fetchFn: query => fetchAdvisories({ locale, query: { results: 5, search: query } }),
    cacheKey: CacheKey.ADVISORIES,
    mapData: (data, debouncedSearch) =>
      data.data.map((advisory: Advisory) => (
        <AdvisorySearchItem
          key={`product-${advisory.id}`}
          advisory={advisory}
          searchQuery={debouncedSearch}
        />
      )),
  });

  const openDialog = useDialogStore(s => s.open);

  const handleCreateAdvisoryClick = () => {
    // if (!me) {
    //   // router.push(ROUTES.SIGN_IN());
    //   openDialog({
    //     id: SignInDialog.id,
    //     content: <SignInDialog />,
    //   });
    //   return;
    // }

    openDialog({
      id: AddAdvisoryDialog.id,
      content: <AddAdvisoryDialog />,
    });
  };

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-between gap-4 px-4 sm:px-0 md:flex-row',
        'ea-advisorypage-header-wrapper',
        props.className?.wrapper,
      )}
    >
      <span
        className={cn(
          'col-span-12 whitespace-nowrap align-middle text-3xl font-semibold lg:col-span-3',
          'ea-advisorypage-header__heading',
          props.className?.header,
        )}
      >
        {t('text475')}
      </span>
      <div className="pxmd:px-0 flex w-full flex-col justify-end gap-4 md:flex-row">
        <div
          className={cn(
            'flex items-center justify-center gap-2',
            'ea-advisorypage-searchbar-wrapper',
          )}
        >
          <SearchBar
            items={items}
            isLoading={isLoading}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            className={{
              input: {
                wrapper: ' border-none bg-input md:max-w-[300px]',
              },
            }}
          />
        </div>
        <Button
          className={cn(
            'flex items-center justify-center gap-2 rounded-full py-3',
            'ea-advisorypage-add-advisory-button',
          )}
          onClick={handleCreateAdvisoryClick}
        >
          <FiEdit3 />
          <span className={cn('', 'ea-advisorypage-add-advisory-button__text')}>
            {t('text635')}
          </span>
        </Button>
      </div>
    </div>
  );
}
